<template>
    <div class="app-container">
        <div class="x-nav">
            <el-breadcrumb :separator="'＞'">
                <el-breadcrumb-item @click="cancel"><a>英语强化</a></el-breadcrumb-item>
                <el-breadcrumb-item>英语强化课程详情</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <el-card shadow="never" class="detail-card">
            <el-descriptions :column="3" title="基本信息">
                <el-descriptions-item label="课程名称">{{ form.courseName }}</el-descriptions-item>
                <el-descriptions-item label="课程类型">{{ form.stageTypeName }}</el-descriptions-item>
                <el-descriptions-item label="是否公共资源">{{ form.isCommon == 0 ? '否' : '是' }}</el-descriptions-item>
                <el-descriptions-item label="主讲人">{{ form.userName }}</el-descriptions-item>
                <el-descriptions-item label="封面" :span="3">
                    <img v-if="form.courseCover" :src="form.courseCover" class="course-cover" />
                </el-descriptions-item>
                <el-descriptions-item label="简介" :span="3">{{ form.courseRecommend }}</el-descriptions-item>
                <el-descriptions-item v-if="recommendImgList.length" label="介绍图片" :span="3">
                    <div class="recommend-img-list">
                        <img v-for="item in recommendImgList" :key="item" :src="item" class="recommend-img" />
                    </div>
                </el-descriptions-item>
            </el-descriptions>
        </el-card>
    </div>
</template>

<script>
import { stuCourseInfo } from "@/api/admin/stuCourse.js"

export default {
    name: "englishImproveCourseDetail",
    data() {
        return {
            courseId: '',
            // 表单参数
            form: {},
            recommendImgList: [],
        };
    },
    mounted() {
        if (this.$route.query.courseId) {
            this.courseId = this.$route.query.courseId
            this.getCourseInfo()
        }
    },
    methods: {
        getCourseInfo() {
            stuCourseInfo({ courseId: this.courseId }).then(res => {
                if (res.data.code == 1) {
                    this.form = res.data.data;
                    this.recommendImgList = res.data.data.recommendImgList || [];
                }else{
                    this.$message.error("请求出错")
                }
                
            })
        },
        // 取消按钮
        cancel() {
            this.replace('/englishImprove')
        },
    }
};
</script>
<style scoped>
.detail-card {
    height: calc(100vh - 160px);
    overflow: auto;
}

.course-cover {
    width: 270px;
    height: 152px;
    display: block;
    object-fit: cover;
}

.recommend-img-list {
    display: flex;
    flex-wrap: wrap;
}

.recommend-img {
    width: 148px;
    height: 148px;
    margin-right: 5px;
    margin-bottom: 5px;
}
</style>
